import { useEffect, useState } from "react";

export default function CreateApiKeyModal({ isOpen, onClose, onSubmit, busy }) {
  const [name, setName] = useState("");
  const [scopesJson, setScopesJson] = useState("[]");

  useEffect(() => {
    if (!isOpen) {
      setName("");
      setScopesJson("[]");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-lg bg-white border border-slate-200 shadow-xl">
        <div className="px-5 py-4 border-b border-slate-200">
          <h3 className="text-lg font-semibold text-slate-800">Create API Key</h3>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Name
            </label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm"
              placeholder="Zapier Production"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Scopes JSON (optional)
            </label>
            <p className="mb-2 text-xs text-slate-500">
              Leave this empty for most setups. Use only for advanced scoped
              access.
            </p>
            <textarea
              value={scopesJson}
              onChange={e => setScopesJson(e.target.value)}
              rows={3}
              className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm"
              placeholder='["message.sent"]'
            />
          </div>
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-slate-300 px-3 py-2 text-sm hover:bg-slate-50"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={busy || !name.trim()}
            onClick={() => onSubmit({ name: name.trim(), scopesJson })}
            className="rounded-md bg-emerald-600 px-3 py-2 text-sm text-white disabled:opacity-60"
          >
            {busy ? "Creating..." : "Create Key"}
          </button>
        </div>
      </div>
    </div>
  );
}
